import { FC, useState } from "react";
import styles from "./Comments.module.scss";
import { TComment } from "../../../types/comment";
import { formatDate } from "../../../utils/utils";
import { Button } from "../Button/Button";
import { useAppSelector } from "../../../services/hooks";
import deleteIcon from "../../../images/icons/delete.svg";
import report from "../../../images/icons/report.svg";
import { TClaimPost } from "../../../types/claim";
import { createClaims } from "../../../api/claim";
import { ErrorPage } from "../../../pages/ErrorPage/ErrorPage";
import close from "../../../images/icons/clear.svg";

interface IComments {
  dataComments: TComment[];
  addComment?: () => void;
  description?: string;
  setDescription: (value: string) => void;
  userType: "client" | "model" | "admin";
  handleDelete: (id: number) => void;
}

export const Comments: FC<IComments> = ({
  dataComments,
  addComment,
  description,
  setDescription,
  userType,
  handleDelete,
}) => {
  const { user } = useAppSelector((state) => state.user);
  const [isLoading, setIsLoading] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [popupText, setPopupText] = useState("");

  async function handleComplain(id: number) {
    try {
      setIsLoading(true);
      const claim: TClaimPost = {
        commentId: id,
      };
      await createClaims(claim);
      setPopupText("Der Kommentar wurde erfolgreich zur Überprüfung gesendet");
      setOpenPopup(true);
    } catch {
      setPopupText(
        "Eine Beschwerde über diesen Kommentar existiert bereits, erwarten Sie",
      );
      setOpenPopup(true);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className={styles.comments}>
      <ul className={styles.comments_list}>
        {dataComments && dataComments.length > 0 ? (
          dataComments.map((comment) => (
            <li className={styles.comments_list_item}>
              <p className={styles.date}>{formatDate(comment.createdAt)}</p>
              <p className={styles.text}>
                {comment.comment}
                {user?.type === "admin" && (
                  <img
                    className={styles.icon}
                    src={deleteIcon}
                    onClick={() => handleDelete(comment.id)}
                    alt="Icon"
                  ></img>
                )}
                {user?.type === "model" && (
                  <img
                    className={styles.icon}
                    src={report}
                    onClick={() => handleComplain(comment.id)}
                    alt="Icon"
                  ></img>
                )}
              </p>
            </li>
          ))
        ) : (
          <p>Keine Kommentare</p>
        )}
      </ul>
      {userType === "client" && (
        <>
          <div className={styles.textareaBlock}>
            <div className={styles.inputGroup}>
              <label className={styles.inputLabel}>Beschreibung</label>
              <textarea
                placeholder="Enter beschreibung..."
                value={description}
                className={styles.textarea}
                onChange={(e) => setDescription(e.target.value)}
              ></textarea>
            </div>
          </div>
          <div className={styles.Button}>
            <Button type="button" onClick={addComment}>
              Add
            </Button>
          </div>
        </>
      )}
      <div className={`${styles.popup} ${openPopup && styles.popup_opened}`}>
        <img
          className={styles.popup_iconCloseNotify}
          onClick={() => setOpenPopup(false)}
          src={close}
          alt="iconClose"
        />
        <div className={styles.popup_containerNotify}>
          <h5>{popupText}</h5>
        </div>
      </div>
    </div>
  );
};
